import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { MenuListProps } from '../../constants';
import { FilterSelectProps } from './types';

type Hack = (event: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
}>, child: React.ReactNode) => void;

const FilterSelect = ({ options, handleChange, value, fieldName, label }: FilterSelectProps) => {
    return (
        <FormControl size='small' fullWidth variant="outlined">
            <InputLabel id={`${fieldName}-label`}>{label}</InputLabel>
            <Select
                label={label}
                labelId={`${fieldName}-label`}
                id={fieldName}
                value={value}
                name={fieldName}
                MenuProps={MenuListProps}
                onChange={handleChange as unknown as Hack}
            >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
                {options.map(({ id, name }) => (
                    <MenuItem key={id} value={id}>{name}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default FilterSelect;
